import { forwardRef, PropsWithChildren } from 'react'

import PersonIcon from '@mui/icons-material/Person'
import { Avatar, AvatarProps, useTheme } from '@mui/material'
import { stringForAvatar } from '@/utils/stringForAvatar'

type UserAvatarProps = {
  size?: number
  name?: string
} & PropsWithChildren<AvatarProps>

export const UserAvatar = forwardRef<HTMLDivElement, UserAvatarProps>(
  ({ size = 32, children, name, ...props }, ref) => {
    const theme = useTheme()

    return (
      <Avatar
        ref={ref}
        {...props}
        sx={{
          width: size,
          height: size,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          fontSize: size * 0.4,
          position: 'relative',

          '& .MuiIcon-root': {
            display: 'none'
          },
          '&:hover': {
            '& .MuiIcon-root': {
              display: 'block'
            }
          },
          '& img': {
            width: size,
            objectFit: 'contain'
          },
          ...props?.sx
        }}
      >
        {name ? <span>{stringForAvatar(name)}</span> : <PersonIcon sx={{ fontSize: 24 }} />}
        {children}
      </Avatar>
    )
  }
)

UserAvatar.displayName = 'UserAvatar'
